export interface CadastralAndDirectionModel {
  cadastralReference: string;
  direction: string;
}
